import styled from 'styled-components';

export const TypeFilterContainer = styled.div`
  > div {
    margin: 0;
    padding: 0;
    flex-wrap: wrap;
  }

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    label {
      cursor: pointer;
      padding: 0;
      height: 45px;

      &::after {
        display: none;
      }
    }

    .children-type {
      padding-left: 20px;
      position: relative;

      &::before {
        left: 5px;
        position: absolute;
        content: '•';
        color: ${({ theme }) => theme.colors.text.primary};
        margin-right: 8px;
        font-size: 16px;
      }
    }
  }
`;
